import { InternalTagGroup, TagGroupMutation, TagGroupOrder } from '../features/tag-groups/types/InternalTagGroup'
import { internalApiserverApi } from './internal-apiserver'

const tagGroupsApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['internalTagGroups', 'languageMaps'] }).injectEndpoints({
  endpoints: (builder) => ({
    getInternalTagGroups: builder.query<InternalTagGroup[], void>({
      query: () => 'tag-groups/list',
      providesTags: ['internalTagGroups'],
    }),
    // Creates without an `id`, updates with one. The backend writes `translations` into the language maps.
    saveTagGroup: builder.mutation<InternalTagGroup, TagGroupMutation>({
      query: (tagGroup) => ({ url: 'i/tag-groups', method: 'POST', body: tagGroup }),
      invalidatesTags: ['internalTagGroups', 'languageMaps'],
    }),
    deleteTagGroup: builder.mutation<void, string>({
      query: (id) => ({ url: `i/tag-groups/${id}`, method: 'DELETE' }),
      invalidatesTags: ['internalTagGroups', 'languageMaps'],
    }),
    saveTagGroupOrder: builder.mutation<void, TagGroupOrder>({
      query: (order) => ({ url: 'i/tag-groups/order', method: 'PUT', body: order }),
      invalidatesTags: ['internalTagGroups'],
    }),
  }),
})

export const { useGetInternalTagGroupsQuery, useSaveTagGroupMutation, useDeleteTagGroupMutation, useSaveTagGroupOrderMutation } = tagGroupsApi
